export default {
  creditCardList: {},
  invoiceExtractList: {},
  invoiceData: {},
  automaticPaymentList: {},
  allInvoiceIds: [],
  hasCreditCard: {},
  electronicBill: {},
  payBy3dStatus: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/financial/state.js